interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="flex h-10 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm text-foreground-800 transition-colors hover:border-primary-500 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-10 w-10 rounded-md border text-sm font-medium transition-colors ${
            page === currentPage
              ? 'border-primary-500 bg-primary-500 text-foreground-950'
              : 'border-background-300 text-foreground-800 hover:border-primary-500'
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="flex h-10 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm text-foreground-800 transition-colors hover:border-primary-500 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}